// extracted by mini-css-extract-plugin
export default {"arrowIcon":"styles_arrowIcon__lyYMU"};